import { OffersClickoutGuard as e } from "../offers-clickout/index.js";
import { Component as t, Suspense as n } from "react";
import { jsx as r } from "react/jsx-runtime";
import { useTranslation as i } from "react-i18next";
import a from "@cx-modules/offers-grouped";
//#region page-template/OffersGrouped/OffersGrouped.tsx
var o = class extends t {
	state = { hasError: !1 };
	static getDerivedStateFromError() {
		return { hasError: !0 };
	}
	componentDidCatch(e) {
		this.props.onError?.(e);
	}
	render() {
		return this.state.hasError ? null : this.props.children;
	}
}, s = ({ onError: t, ...s }) => {
	let { i18n: c } = i(), l = {
		...s,
		i18n: c
	};
	return /* @__PURE__ */ r(o, {
		onError: t,
		children: /* @__PURE__ */ r(n, {
			fallback: null,
			children: /* @__PURE__ */ r(e, {
				componentName: "OffersGrouped",
				values: l,
				children: /* @__PURE__ */ r(a, { ...l })
			})
		})
	});
}, c = ({ geoTargeting: e, ocApiKey: t, repub: n, subdivision: r, visibleOffersCount: i, ...a }) => ({
	...a,
	apiKey: t,
	initialOffersToShow: i,
	subdivisionCode: r,
	theme: `oc${n.toLowerCase()}`,
	repub: n,
	geoTargeting: e,
	...e === !1 ? {
		countryCode: void 0,
		subdivisionCode: void 0
	} : {}
});
//#endregion
export { s as OffersGrouped, c as OffersGroupedContentContractForPageTemplate };
